<template>
  <agency-agency-projects-list
    class="approved-agency-projects-view"
    header="Wszystkie projekty w krajach placówki"
    icon="business"
    empty-warning="Nie ma jeszcze żadnego projektu w krajach placówki"
  >
  </agency-agency-projects-list>
</template>

<script>
import AgencyAgencyProjectsList from "./components/AgencyAgencyProjectsList";

export default {
  name: "ApprovedAgencyProjectsView",
  components: { AgencyAgencyProjectsList }
};
</script>